/*
 * � 2020 Microsoft. All rights reserved.
 */

define('MenuUI/ChallengeKickoff',['pixi', 'absolute', 'lodash', 'MenuUI/MsftButton', 'MenuUI/MsftRectButton', 'MenuUI/ControlFocusManager', 'MenuUI/ColorConstants', 'absolute/stringmanager'],

    function (PIXI, Absolute, _, MsftButton, MsftRectButton, ControlFocusManager, ColorConstants, StringManager) {

        var ChallengeKickoff = function (config, ui, game) {
            this.fontSize = Absolute.ScreenMetrics.getResScale() * 40;

            var defaultConfig = {
                headline: 'Fix headline',
                goalText: 'Fix goalText',
                gameDifficulty: 'Easy',
                rewardAmount: '0',
                bonusText: 'Complete all of the day\'s Challenges to get',
                bonusAmount: '0',
                currencyIcon: 'DC_kickoff_coin.png',
                letterStyleHeadline: {
                    font: Absolute.ScreenMetrics.getResScale() * 40 + "px Arial",
                    fontFamily: 'segoe',
                    fill: '#ffffff',
                    align: 'left'
                },
                letterStyleLabel: {
                    font: 'Bold ' + Absolute.ScreenMetrics.getResScale() * 30 + "px Arial",
                    fontFamily: 'segoe',
                    fill: '#ffffff',
                    align: 'left'
                },
                letterStyleContent: {
                    font: Absolute.ScreenMetrics.getResScale() * 30 + "px Arial",
                    fontFamily: 'segoe',
                    fill: '#ffffff',
                    align: 'left'
                },
                completed: false,
                playAction: function () {
                    game.solitaire.DealNewGame();
                }
            };
            this.initChallengeKickoff(_.extend(defaultConfig, config), ui, game);
        };

        ChallengeKickoff.prototype = Object.create(PIXI.DisplayObjectContainer.prototype);

        ChallengeKickoff.prototype.bindInteraction = function (sprite, handler) {

            sprite.interactive = true;
            sprite.buttonMode = true;

            if (Absolute.Platform.supportsTouch()) {
                sprite.touchstart = handler.bind(this);
                if (Absolute.Platform._isWindows() || (Absolute.Platform._isMac() && !Absolute.Platform._isIOS())) {
                    sprite.mousedown = handler.bind(this);
                    sprite.mouseup = function () {
                    };
                }
            } else {
                sprite.mousedown = handler.bind(this);
                sprite.mouseup = function () {
                };
            }

        };

        ChallengeKickoff.prototype.initChallengeKickoff = function (config, ui, game) {

            PIXI.DisplayObjectContainer.call(this);

            var _s = Absolute.StringManager,
                _c = Absolute.Coords.x,
                rightColX = _c(255);

            this.config = config;
            this.game = game;
            this.ui = ui;

            this.state = 'init';
            this.animationStarted = false;

            this.kickOffContainer = new PIXI.DisplayObjectContainer();
            this.descriptionContainer = new PIXI.DisplayObjectContainer();
            this.headlineContainer = new PIXI.DisplayObjectContainer();

            var mask = new PIXI.Graphics();
            mask.clear();
            mask.beginFill(0xffffff, 1);
            mask.drawRect(0, 0, Absolute.Coords.x(1920), Absolute.Coords.y(433));
            mask.endFill();
            this.kickOffContainer.addChild(mask);
            this.kickOffContainer.mask = mask;

            // junk for animations
            this.godSparkleLeft = PIXI.Sprite.fromFrame('ray.png');
            this.godSparkleRight = PIXI.Sprite.fromFrame('glow2.png');
            this.godSparkleLeft.x = -_c(102);
            this.godSparkleLeft.y = _c(159);
            this.godSparkleRight.x = _c(246);
            this.godSparkleRight.y = _c(378);

            // intercept cheater clicks. people shouldn't ignore our bling
            this.inputInterceptOverlay = new PIXI.Graphics();
            this.inputInterceptOverlay.beginFill(0x000001, 0);
            this.inputInterceptOverlay.drawRect(0, 0, this.ui.width, this.ui.height);
            this.inputInterceptOverlay.endFill();
            this.inputInterceptOverlay.interactive = true;
            this.inputInterceptOverlay.buttonMode = false;
            this.inputInterceptOverlay.hitArea = new PIXI.Rectangle(0, 0, this.ui.width, this.ui.height);
            this.bindInteraction(this.inputInterceptOverlay, function () {
            }.bind(this));
            this.addChild(this.inputInterceptOverlay);

            // kickoff content
            this.drawBackground();

            this.icon = PIXI.Sprite.fromFrame(this.config.icon);
            this.icon.x = _c(167);
            this.icon.y = _c(0);

            this.headline = new PIXI.Text(_s(this.config.headlineText).replace("\n", ""), this.config.letterStyleHeadline);
            this.headline.anchor.set(0, 0.5);
            this.headline.x = _c(265);
            this.headline.y = this.headline.height / 2 + _c(7);

            this.goalHeadline = new PIXI.Text(_s('kickoff.goal'), this.config.letterStyleHeadline);
            var fontSize = StringManager.extractNumbersFromString( this.config.letterStyleHeadline.font);
            StringManager.shrinkToFit(this.goalHeadline, fontSize, '', Absolute.ScreenMetrics.getResScale() * 105);
            this.goalHeadline.anchor.set(0.5, 0.5);
            this.goalHeadline.x = _c(70) + this.goalHeadline.width/2;
            this.goalHeadline.y = _c(35);
            this.goalHeadline.visible = false;

            this.goalLabel = this.getTextSprite('kickoff.goal', this.config.letterStyleLabel, 'right', 230, 90);
            this.goalText = new PIXI.Text(_s(this.config.goalText),  _.cloneDeep(this.config.letterStyleContent));
            this.goalText.x = rightColX;
            this.goalText.y = _c(91);

            this.difficultyLabel = this.getTextSprite('kickoff.difficulty', this.config.letterStyleLabel, 'right', 230, 159);
            this.difficultyText = new PIXI.Text(_s(this.config.gameDifficulty),  _.cloneDeep(this.config.letterStyleContent));
            this.difficultyText.x = rightColX;
            this.difficultyText.y = _c(160);

            this.rewardLabel = this.getTextSprite('kickoff.reward', this.config.letterStyleLabel, 'right', 230, 224);
            if (this.config.complete) {
                this.rewardText = new PIXI.Text(_s('dialogs.alreadyEarned'),_.cloneDeep(this.config.letterStyleContent));
                this.rewardText.x = rightColX;
                this.rewardText.y = _c(225);
            } else {
                this.rewardCurrency = this.getCurrencySprite(this.config.rewardAmount);
                this.rewardCurrency.x = rightColX;
                this.rewardCurrency.y = _c(225);
            }

            this.bonusLabel = this.getTextSprite('kickoff.bonus', this.config.letterStyleLabel, 'right', 230, 288);
            this.bonusText = new PIXI.Text(_s(this.config.bonusText), _.cloneDeep(this.config.letterStyleContent));
            this.bonusText.x = rightColX;
            this.bonusText.y = _c(289);
            this.bonusCurrency = this.getCurrencySprite(this.config.bonusAmount);
            this.bonusCurrency.x = this.bonusText.x + this.bonusText.width + _c(10);
            this.bonusCurrency.y = _c(289);

            this.name = new PIXI.Text(_s(this.config.gameName), this.config.letterStyleContent);
            this.name.anchor.set(0.5, 0.5);
            Absolute.StringManager.shrinkToFit(this.name, Absolute.StringManager.extractNumbersFromString(this.config.letterStyleContent.font), '', Absolute.Coords.x(160));
            this.name.x = this.icon.x - this.name.width / 2 - _c(5);
            this.name.y = _c(37);

            this.playButton = new MsftButton({
                'text': Absolute.StringManager('buttons.play'),
                'threeSlice': {
                    multistate: true,
                    images: {
                        'left': 'MS_3slice_btn_bluemodal_01.png',
                        'center': 'MS_3slice_btn_bluemodal_02.png',
                        'right': 'MS_3slice_btn_bluemodal_03.png'
                    }
                },
                'maxWidth': Absolute.ScreenMetrics.getResScale() * 63,
                keepTintOnDown: true,
                maxWidth: Absolute.ScreenMetrics.getResScale() * 63,
                letterStyle: {
                    font: Absolute.ScreenMetrics.getResScale() * 22 + "px Arial",
                    fontFamily: 'segoe',
                    fill: '#ffffff',
                    align: 'left'
                },
                'width': _c(75), 'height': _c(36),
                'action': this.handlePlay.bind(this)
            });
            this.playButton.x = _c(273);
            this.playButton.y = this.config.isStarClub ? _c(300) : _c(365);

            this.cancelButton = new MsftButton({
                'text': Absolute.StringManager('buttons.cancel'),
                'threeSlice': {
                    multistate: true,
                    images: {
                        'left': 'MS_3slice_btn_bluemodal_01.png',
                        'center': 'MS_3slice_btn_bluemodal_02.png',
                        'right': 'MS_3slice_btn_bluemodal_03.png'
                    }
                },
                'maxWidth': Absolute.ScreenMetrics.getResScale() * 80,
                keepTintOnDown: true,
                maxWidth: Absolute.ScreenMetrics.getResScale() * 80,
                letterStyle: {
                    font: Absolute.ScreenMetrics.getResScale() * 22 + "px Arial",
                    fontFamily: 'segoe',
                    fill: '#ffffff',
                    align: 'left'
                },
                'width': _c(95), 'height': _c(36),
                'action': this.game.navBack.bind(this.game)
            });
            this.cancelButton.x = _c(363);
            this.cancelButton.y = this.config.isStarClub ? _c(300) : _c(365);

            this.headlineContainer.addChild(this.icon);
            this.headlineContainer.addChild(this.name);
            this.headlineContainer.addChild(this.headline);
            this.headlineContainer.addChild(this.goalHeadline);
            this.descriptionContainer.addChild(this.goalLabel);
            this.descriptionContainer.addChild(this.goalText);
            this.descriptionContainer.addChild(this.difficultyLabel);
            this.descriptionContainer.addChild(this.difficultyText);
            this.descriptionContainer.addChild(this.rewardLabel);
            if (!this.config.complete) {
                this.descriptionContainer.addChild(this.rewardCurrency);
            }
            if (this.rewardText) this.descriptionContainer.addChild(this.rewardText);
            if (!this.config.isStarClub) {
                this.descriptionContainer.addChild(this.bonusLabel);
                this.descriptionContainer.addChild(this.bonusText);
                this.descriptionContainer.addChild(this.bonusCurrency);
            }
            this.descriptionContainer.addChild(this.playButton);
            this.descriptionContainer.addChild(this.cancelButton);
            this.addPipe(243, 80, this.descriptionContainer);
            this.addPipe(243, 150, this.descriptionContainer);
            this.addPipe(243, 217, this.descriptionContainer);
            if (!this.config.isStarClub) {
                this.addPipe(243, 283, this.descriptionContainer);
            }

            this.kickOffContainer.y = _c(378);

            this.kickOffContainer.addChild(this.descriptionContainer);
            this.kickOffContainer.addChild(this.headlineContainer);
            this.addChild(this.kickOffContainer);

            this.controlFocusManager = new ControlFocusManager();
            this.controlFocusManager.addControl(this.playButton, true);
            this.controlFocusManager.addControl(this.cancelButton, true);
            //this.controlFocusManager.focusNextControl(1);
        };

        ChallengeKickoff.prototype.getBox = function (color, width, height, getGraphic) {
            if (!this.graphics) {
                this.graphics = new PIXI.Graphics();
            }
            getGraphic = !!getGraphic;
            this.graphics.clear();
            this.graphics.beginFill(color, 1);
            this.graphics.drawRect(0, 0, Absolute.Coords.x(width), Absolute.Coords.x(height));
            this.graphics.endFill();
            return getGraphic ? graphics : this.graphics.generateTexture();
        };

        ChallengeKickoff.prototype.drawBackground = function () {

            if (this.config.isStarClub) {
                this.baseBackground = new PIXI.Sprite(this.getBox(0x184793, 1920, 368));
            } else {
                this.baseBackground = new PIXI.Sprite(this.getBox(0x184793, 1920, 433));
            }
            this.topLeftBackground = new PIXI.Sprite(this.getBox(ColorConstants[this.config.gameName], 246, 60));
            this.topRightBackground = new PIXI.Sprite(this.getBox(ColorConstants[this.config.gameName], 1674, 60));

            this.topRightBackground.x = this.topLeftBackground.width;
            this.descriptionContainer.addChild(this.baseBackground);
            this.headlineContainer.addChild(this.topLeftBackground);
            this.headlineContainer.addChild(this.topRightBackground);
            this.addPipe(this.topLeftBackground.width - 3, 3, this.headlineContainer);
        };

        ChallengeKickoff.prototype.getCurrencySprite = function (amount) {

            var container = new PIXI.DisplayObjectContainer();

            if (this.config.isStarClub) {
                _.times(amount, function (index) {
                    var currency = PIXI.Sprite.fromFrame(this.config.currencyIcon);
                    currency.x = index * currency.width;
                    container.addChild(currency);
                }, this);
            } else {

                var currency = PIXI.Sprite.fromFrame(this.config.currencyIcon),
                    multiply = new PIXI.Text('x', this.config.letterStyleLabel),
                    number = new PIXI.Text(Absolute.StringManager(amount), this.config.letterStyleLabel);
                multiply.anchor.set(0.5, 0.5);
                number.anchor.set(0.5, 0.5);

                multiply.x = currency.width + Absolute.Coords.x(10) + multiply.width / 2;
                multiply.y = currency.height / 2;

                number.x = multiply.x + multiply.width / 2 + Absolute.Coords.x(10) + number.width / 2;
                number.y = currency.height / 2;

                container.addChild(currency);
                container.addChild(multiply);
                container.addChild(number);
            }

            return new PIXI.Sprite(container.generateTexture());

        };

        ChallengeKickoff.prototype.getTextSprite = function (text, style, align, x, y) {

            var t = new PIXI.Text(Absolute.StringManager(text), style),
                tSprite = new PIXI.Sprite(t.generateTexture());

            if (align == 'right') {
                tSprite.anchor.x = 1;
            }

            tSprite.x = Absolute.Coords.x(x);
            tSprite.y = Absolute.Coords.y(y);

            return tSprite;

        };

        ChallengeKickoff.prototype.addPipe = function (x, y, parent) {

            if (!this.pipeTexture) {
                var pipeGraphic = new PIXI.Graphics();
                pipeGraphic.beginFill(0xffffff, 1);
                pipeGraphic.drawRect(0, 0, Absolute.Coords.x(2), Absolute.Coords.x(55));
                pipeGraphic.endFill();
                this.pipeTexture = pipeGraphic.generateTexture();
            }

            var pipe = new PIXI.Sprite(this.pipeTexture);

            pipe.x = Absolute.Coords.x(x);
            pipe.y = Absolute.Coords.x(y);
            parent.addChild(pipe);

        };

        ChallengeKickoff.prototype.handlePlay = function () {
            var self = this;

            Absolute.AudioManager.playSound('ui_kickOffClose');

            this.playButton.interactive = false;
            this.cancelButton.interactive = false;
            this.name.visible = false;

            this.playTween = new TWEEN.Tween({y: 0})
                .to({y: -this.baseBackground.height}, 300)
                .easing(TWEEN.Easing.Quadratic.In)
                .onUpdate(function () {
                    self.descriptionContainer.y = this.y
                })
                .onComplete(function () {
                    self.config.playAction();
                    self.inputInterceptOverlay.visible = false;
                    self.animationStarted = true;
                })
                .start();

            this.sparkleTween = new TWEEN.Tween({alpha: 0})
                .delay(500)
                .to({alpha: [1, 0]}, 800)
                .onStart(function () {
                    self.addChild(self.godSparkleLeft);
                    self.addChild(self.godSparkleRight);
                    self.headline.setText(Absolute.StringManager(self.config.goalText));
                    self.goalHeadline.visible = true;
                })
                .easing(TWEEN.Easing.Quadratic.Out)
                .onUpdate(function () {
                    self.godSparkleLeft.alpha = this.alpha;
                    self.godSparkleRight.alpha = this.alpha
                })
                .onComplete(function () {

                });

            this.slideDownTween = new TWEEN.Tween({y: this.kickOffContainer.y})
                .delay(500)
                .to({y: this.ui.height - this.topLeftBackground.height}, 800)
                .easing(TWEEN.Easing.Quadratic.InOut)
                .onStart(function () {
                    Absolute.AudioManager.playSound('dc_fly');
                })
                .onUpdate(function () {
                    self.kickOffContainer.y = this.y;
                })
                .onComplete(function () {
                    self.state = 'collapsed';
                });

            this.playTween.chain(this.sparkleTween);
            this.sparkleTween.chain(this.slideDownTween);

        };

        ChallengeKickoff.prototype.onShow = function () {

        };


        ChallengeKickoff.prototype.handleCommand = function (command) {
            switch (command) {
                case 'Tab':
                case 'Right':
                    this.controlFocusManager.focusNextControl(1);
                    break;
                case 'ShiftTab':
                case 'Left':
                    this.controlFocusManager.focusNextControl(-1);
                    break;
                case 'Activate':
                    this.controlFocusManager.activateCurrentControl();
                    break;
            }
        };

        return ChallengeKickoff;

    });

